let ticketSelectionAmount = 0;

export function setTicketSelectionAmount(amount) {
     ticketSelectionAmount = amount;
}

export function getTicketSelectionAmount() {
    return ticketSelectionAmount;
}